//tokens
const STORAGEKEY_TOKEN = 'token_api';
const STORAGEKEY_TOKEN_LOGIN = 'token_login';

//webapis
const STORAGEKEY_URL_API_AGENDASERVICOS = 'url_agendaservicos_api';
const STORAGEKEY_URL_API_SUPRIMENTOS = 'url_suprimentos_api';
const STORAGEKEY_URL_API_CRM = 'url_crm_api';

//webapps
const STORAGEKEY_URL_VENDAFACIL = 'url_vendafacil';
const STORAGEKEY_URL_ERP_WEBAPP = 'url_erp_webapp';

const urlAgendaServicosApiDev = process.env.VUE_APP_URL_AGENDASERVICOSAPI;
const urlVendaFacilDev = process.env.VUE_APP_URL_VENDAFACIL;
const urlErpWebAppDev = process.env.STORAGEKEY_URL_ERP_WEBAPP;
const urlSuprimentosApiDev = process.env.VUE_APP_URL_SUPRIMENTOSAPI;
const urlCrmApiDev = process.env.VUE_APP_URL_CRMAPI;

const apiConfig = {
  getToken: () => localStorage.getItem(STORAGEKEY_TOKEN) || '',
  getTokenLogin: () => localStorage.getItem(STORAGEKEY_TOKEN_LOGIN) || '',
  getUrlAgendaServicosApi: () => urlAgendaServicosApiDev || localStorage.getItem(STORAGEKEY_URL_API_AGENDASERVICOS) || '',
  getUrlVendaFacil: () => urlVendaFacilDev || localStorage.getItem(STORAGEKEY_URL_VENDAFACIL) || '',
  getUrlErpWebApp: () => urlErpWebAppDev || localStorage.getItem(STORAGEKEY_URL_ERP_WEBAPP) || '',
  getUrlErpAdminApi: () => process.env.VUE_APP_URL_ERPADMIN,
	getUrlSuprimentosApi: () => urlSuprimentosApiDev || localStorage.getItem(STORAGEKEY_URL_API_SUPRIMENTOS) || '',
	getUrlCrmApi: () => urlCrmApiDev || localStorage.getItem(STORAGEKEY_URL_API_CRM) || '',

  setToken: (val) => {
    if (!val)
      localStorage.removeItem(STORAGEKEY_TOKEN);
    else
      localStorage.setItem(STORAGEKEY_TOKEN, val);
  },

  setTokenLogin: (val) => {
    if (!val)
      localStorage.removeItem(STORAGEKEY_TOKEN_LOGIN);
    else
      localStorage.setItem(STORAGEKEY_TOKEN_LOGIN, val);
  },

  setUrlAgendaServicosApi: (val) => {
    if (!val)
      localStorage.removeItem(STORAGEKEY_URL_API_AGENDASERVICOS);
    else
      localStorage.setItem(STORAGEKEY_URL_API_AGENDASERVICOS, val);
  },

  setUrlVendaFacil: (val) => {
    if (!val)
      localStorage.removeItem(STORAGEKEY_URL_VENDAFACIL);
    else
      localStorage.setItem(STORAGEKEY_URL_VENDAFACIL, val);
  },

  setUrlErpWebApp: (val) => {
    if (!val)
      localStorage.removeItem(STORAGEKEY_URL_ERP_WEBAPP);
    else
      localStorage.setItem(STORAGEKEY_URL_ERP_WEBAPP, val);
  },

  setUrlSuprimentosApi: (val) => {
		if (!val)
			localStorage.removeItem(STORAGEKEY_URL_API_SUPRIMENTOS);
		else
			localStorage.setItem(STORAGEKEY_URL_API_SUPRIMENTOS, val);
	},

  setUrlCrmApi: (val) => {
		if (!val)
			localStorage.removeItem(STORAGEKEY_URL_API_CRM);
		else
			localStorage.setItem(STORAGEKEY_URL_API_CRM, val);
	},

  reset: () => {
    localStorage.removeItem(STORAGEKEY_TOKEN);
    localStorage.removeItem(STORAGEKEY_TOKEN_LOGIN);
    localStorage.removeItem(STORAGEKEY_URL_API_AGENDASERVICOS);
    localStorage.removeItem(STORAGEKEY_URL_VENDAFACIL);
    localStorage.removeItem(STORAGEKEY_URL_ERP_WEBAPP);
    localStorage.removeItem(STORAGEKEY_URL_API_SUPRIMENTOS);
    localStorage.removeItem(STORAGEKEY_URL_API_CRM);
  }
};

export default apiConfig;
